// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__27-oo","cell":"ColumnAccessor_cell__3IzS_","firstCellAccent":"ColumnAccessor_firstCellAccent__1L52f"};